'use client'
import { InjectedWalletBase } from '../../injected/InjectedWalletBase.js';

const getConnectorConstructorInjectedWallet = (key, wallet) => {
    const { shortName } = wallet;
    const name = shortName || wallet.name;
    const walletConnectorFallback = Boolean(wallet.walletConnect);
    return class extends InjectedWalletBase {
        constructor() {
            super(...arguments);
            this.name = name;
            this.walletConnectorFallback = walletConnectorFallback;
            // this is the key from the wallet book entry so that we don't purely rely on the normalized name
            this.overrideKey = key;
        }
    };
};

export { getConnectorConstructorInjectedWallet };
